import { useEffect, useRef, useState } from 'react';
import { Spinner, StatusMessage } from '@vwfs-bronson/bronson-react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { redirectCheckout } from '../actions/globalAction';

const defaultUserError =
  'No se ha podido completar la solicitud en este momento. Por favor, inténtelo de nuevo más tarde.';

export const CheckoutPage = () => {
  const dispatch = useDispatch();
  const { checkoutId } = useParams();
  const processedCheckoutId = useRef();
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const requestId = checkoutId ?? '';
    if (processedCheckoutId.current === requestId) {
      return;
    }

    processedCheckoutId.current = requestId;

    const executeCheckout = async () => {
      try {
        const success = await dispatch(redirectCheckout(checkoutId));

        if (!success) {
          setHasError(true);
        }
      } catch (error) {
        console.error('Unexpected error executing checkout:', error);
        setHasError(true);
      }
    };

    executeCheckout();
  }, [checkoutId, dispatch]);

  if (hasError) {
    return <StatusMessage status="error" label={defaultUserError} />;
  }

  return (
    <Spinner fullPage>
      <p>Te estamos redirigiendo...</p>
    </Spinner>
  );
};
